export const formGeneratorTypes = {
  ADD_INPUT: "ADD_INPUT",
  EDIT_INPUT: "EDIT_INPUT",
  DEL_INPUT: "DEL_INPUT",
  SELECT_INPUT: "SELECT_INPUT",
  CLEAN_SELECT_INPUT: "CLEAN_SELECT_INPUT",
}